import { Button, Label, TextInput } from "flowbite-react";
import { useState } from "react";
import toast from "react-hot-toast";
import { useAuth } from "../../contexts/AuthContext";
import { updateUserData } from "../../api/auth";

const ProfileSettings = () => {
  const [isProcessing, setIsProcessing] = useState(false);
  const { user, updateUser } = useAuth();

  const [formData, setFormData] = useState({
    firstName: user?.firstName || '',
    lastName: user?.lastName || '',
    email: user?.email || '',
    telegram: user?.telegram || '',
  });

  const handleChange = e => {
    const { name, value } = e.target;

    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    setIsProcessing(true);

    try {
      const data = await updateUserData(formData);

      updateUser(data);

      toast.success('Settings have been saved');
    } catch (error) {
      console.error(error);
      toast.error('Unable to save settings');
    } finally {
      setIsProcessing(false);
    }
  }

  return (
    <form onSubmit={handleSubmit}>
      <div className="mb-4 grid gap-4 sm:mb-6 sm:grid-cols-2">
        <div>
          <div className="mb-2 block">
            <Label htmlFor="firstName" value="First Name" />
          </div>
          <TextInput
            id="firstName"
            name="firstName"
            value={formData.firstName}
            onChange={handleChange}
          />
        </div>
        <div>
          <div className="mb-2 block">
            <Label htmlFor="lastName" value="Last Name" />
          </div>
          <TextInput
            id="lastName"
            name="lastName"
            value={formData.lastName}
            onChange={handleChange}
          />
        </div>
        <div>
          <div className="mb-2 block">
            <Label htmlFor="email" value="Email" />
          </div>
          <TextInput
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
          />
        </div>
        <div>
          <div className="mb-2 block">
            <Label htmlFor="telegram" value="Telegram ID" />
          </div>
          <TextInput
            id="telegram"
            name="telegram"
            value={formData.telegram}
            onChange={handleChange}
          />
        </div>
      </div>
      <Button
        isProcessing={isProcessing}
        disabled={isProcessing}
        type="submit"
      >
        Save changes
      </Button>
    </form>
  );
}

export default ProfileSettings;
